import * as Cesium from "cesium";
import React from "react";
import usePanoramaPopupStore from "../stores/usePanoramaPopupStore";
import useViewerStore from "../stores/useViewerStore";

type TPanoramaVmItem = {
  index: number;
  position: number[];
  url: string;
  heading?: number;
  cameraHeight?: number;
  view: {
    position: number[];
    orientation: { heading: number; pitch: number; roll: number };
  };
  img: string;
};

const svgContent = `<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_333_334)">
<path d="M26.25 12.5C26.25 21.25 15 28.75 15 28.75C15 28.75 3.75 21.25 3.75 12.5C3.75 9.51631 4.93526 6.65483 7.04505 4.54505C9.15483 2.43526 12.0163 1.25 15 1.25C17.9837 1.25 20.8452 2.43526 22.955 4.54505C25.0647 6.65483 26.25 9.51631 26.25 12.5Z" fill="blue" stroke="#F3F3F3" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15 16.25C17.0711 16.25 18.75 14.5711 18.75 12.5C18.75 10.4289 17.0711 8.75 15 8.75C12.9289 8.75 11.25 10.4289 11.25 12.5C11.25 14.5711 12.9289 16.25 15 16.25Z" fill="blue" stroke="#F3F3F3" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_333_334">
<rect width="30" height="30" fill="blue"/>
</clipPath>
</defs>
</svg>
`;

const svgUrl = `data:image/svg+xml;base64,${btoa(svgContent)}`;
type Entity = Cesium.Entity | Cesium.Entity.ConstructorOptions;

const usePanoramaPins = ({
  items,
  show,
}: {
  items: TPanoramaVmItem[];
  show: boolean;
}) => {
  const { viewer } = useViewerStore();
  const [entities, setEntities] = React.useState<Entity[]>([]);

  const { isOpen, id } = usePanoramaPopupStore();
  React.useEffect(() => {
    if (!viewer) return () => {};

    const es = items.map((p) => {
      return {
        id: `${p.index}`,
        name: `${p.index}`,
        position: Cesium.Cartesian3.fromDegrees(
          p.position[0],
          p.position[1],
          p.position[2],
        ),
        billboard: {
          image: svgUrl,
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          color: id === p.index ? Cesium.Color.SKYBLUE : Cesium.Color.WHITE,
        },
        properties: p,
        show,
      };
    });

    setEntities(es);

    return () => {
      setEntities([]);
    };
  }, [items, setEntities, show, viewer, isOpen, id]);

  React.useEffect(() => {
    if (!viewer || !entities.length) {
      return;
    }

    entities.forEach((entity) => {
      viewer.entities.add(entity);
    });

    // eslint-disable-next-line consistent-return
    return () => {
      entities.forEach((entity) => {
        if (entity.id) viewer.entities.removeById(entity.id);
      });
    };
  }, [viewer, entities]);
};

export default usePanoramaPins;
